module.exports = __webpack_public_path__ + "static/img/level_bg_on.fe3ceb37.png";